import type { App } from 'vue'

declare global {
  interface Window {
    __ctiToast?: {
      success: (msg: string) => void
      error: (msg: string) => void
      info: (msg: string) => void
      warning: (msg: string) => void
    }
  }
}

export function toastSuccess(msg: string) { window.__ctiToast?.success(msg) }
export function toastError(msg: string) { window.__ctiToast?.error(msg) }
export function toastInfo(msg: string) { window.__ctiToast?.info(msg) }
export function toastWarning(msg: string) { window.__ctiToast?.warning(msg) }

export function useToast() {
  return {
    success: toastSuccess,
    error: toastError,
    info: toastInfo,
    warning: toastWarning,
  }
}

export function installToaster(app: App) {
  app.config.globalProperties.$toast = { success: toastSuccess, error: toastError, info: toastInfo, warning: toastWarning }
}